import React from "react";
import HomePage from "./HomePage";
import Footer from "./Footer";
import APCStudyAssistant from "./apc/APCStudyAssistant";

export default function AccountingMaterial() {
  return <><HomePage /><main><APCStudyAssistant /></main><Footer /></>;
}
